module.exports = __webpack_public_path__ + "static/media/cyber-sky-blue.47400abe.svg";